import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Dashboard.css';

/**
 * Home - Versão 2
 * Redireciona admin para AdminMenu e jogador para DashboardJogador
 * Temática: One Piece, Naruto, Pokemon, HxH, Star Wars, Senhor dos Anéis
 */

const Dashboard = () => {
  const { user, isAdmin, role, canAccessJogadores, canAccessRodadas, canAccessFinanceiro, canAccessRanking, canAccessNocautes } = useAuth();

  // Redirecionar admin para menu admin
  if (isAdmin) {
    return <Navigate to="/admin/menu" replace />;
  }

  // Redirecionar jogador para dashboard do jogador
  if (role === 'jogador') {
    return <Navigate to="/dashboard-jogador" replace />;
  }

  // Gerenciador vê o dashboard padrão

  return (
    <div className="container">
      <div className="dashboard-header">
        <div className="nerd-theme-icons">
          <span className="theme-icon">💍</span>
          <span className="theme-icon">🗡️</span>
          <span className="theme-icon">🛡️</span>
          <span className="theme-icon">🏔️</span>
          <span className="theme-icon">🌳</span>
          <span className="theme-icon">⚔️</span>
        </div>
        <h1>Bem-vindo, {user?.nome}!</h1>
        <p>Sistema de gestão para Poker Home Game</p>
        <div className="nerd-quote">
          <p>"Um Anel para a todos governar, Um Anel para encontrá-los..." 💍</p>
        </div>
      </div>

      <div className="dashboard-cards">
        {canAccessJogadores && (
          <Link to="/jogadores" className="dashboard-card-link">
            <div className="dashboard-card">
              <h3>👥 Jogadores</h3>
              <p>Gerencie jogadores, convites e ativações</p>
            </div>
          </Link>
        )}

        {canAccessRodadas && (
          <Link to="/rodadas" className="dashboard-card-link">
            <div className="dashboard-card">
              <h3>🎲 Rodadas</h3>
              <p>Abra rodadas, lance compras e processe fechamentos</p>
            </div>
          </Link>
        )}

        {canAccessRanking && (
          <Link to="/ranking" className="dashboard-card-link">
            <div className="dashboard-card">
              <h3>🏆 Ranking</h3>
              <p>Acompanhe pontuações e nocautes</p>
            </div>
          </Link>
        )}

        {canAccessNocautes && (
          <Link to="/nocautes" className="dashboard-card-link">
            <div className="dashboard-card">
              <h3>🥊 Nocautes</h3>
              <p>Visualize rankings e faça trocas de nocautes</p>
            </div>
          </Link>
        )}

        {canAccessFinanceiro && (
          <Link to="/financeiro" className="dashboard-card-link">
            <div className="dashboard-card">
              <h3>💰 Financeiro</h3>
              <p>Controle de saldos, janta e jackpot</p>
            </div>
          </Link>
        )}
      </div>

      {role && (
        <div className={`role-notice ${role}`}>
          <strong>
            {role === 'admin' && '🔑'}
            {role === 'gerenciador' && '👔'}
            {role === 'jogador' && '👤'}
            {' '}Você é {role === 'admin' ? 'Administrador' : role === 'gerenciador' ? 'Gerenciador' : 'Jogador'}
          </strong>
          <p>
            {role === 'admin' && 'Você tem acesso completo ao sistema'}
            {role === 'gerenciador' && 'Você pode gerenciar rodadas, ranking e financeiro, mas não pode cadastrar jogadores'}
            {role === 'jogador' && 'Você pode visualizar dashboard, ranking e nocautes'}
          </p>
        </div>
      )}
      <footer className="app-footer">
        <div className="footer-content">
          <p className="footer-signature">
            Produzido by <strong>Chicão</strong>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Dashboard;
